
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { BIKES24_SIDEBAR_LIST } from "./constant";
import { useNavigate } from "react-router-dom";
import Header from "../../../Admin-Dashboard/@components/Header";

const Sidebar = ({
  title = "",
  type,
  active_link = "",
  options = [],
}: {
  title?: string;
  type: "data_collection";
  active_link?: string;
  options?: any[];
}) => {
  const navigation = useNavigate();
  const navigate = useNavigate()
  const sidebarOptions = options.length > 0 ? options : BIKES24_SIDEBAR_LIST[type]
  return (
    <div>
      <Header isBikes24={true} />
      <div className="w-[300px]  p-4 h-full border-r-[1px] border-[#d8d9db] mt-20">
        <div className=" flex gap-4 mb-8 items-center px-[16px]">
          <ArrowBackIcon className="cursor-pointer" onClick={() => {
            navigate('/bikes24-dashboard/pages')
          }} />
          <h2 className="text-[24px] font-[400] ">{title}</h2>
        </div>
        <h3 className="text-[12px] px-[16px] text-[#1818196B] font-[500] mb-4">
          {title}
        </h3>
        <div className="flex gap-4 flex-col">
          {sidebarOptions.map((item: any) => (
            <div
              onClick={() => {
                navigation(`${item.link}`);
              }}
              className={`flex gap-2 px-[16px] py-[12px] items-center hover:bg-[#0459BD14] cursor-pointer ${active_link === item.link ? "bg-[#0459BD14]" : ""
                }`}
            >
              <img alt={item.label} src={item.icon} />
              <p className="text-[14px]">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
